import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getAll } from 'store/selectors';
import { ApiDataTypes } from 'api/apiDataTypes';
import EventsTable, { EventsTablePresentation } from './eventsTable';
import { createArchivedEventsRequestedAction } from 'actions/eventActions';

function mapStateToProps(state: ClippingPlatformState) {
  return {
    events: getAll(state.entities.archivedEvents),
    allEventsLoaded: state.appStatus.allLoaded[ApiDataTypes.ArchivedEvents],
    clients: state.entities.archivedClients.byId,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadAllEvents: (c: EventsTablePresentation) => dispatch(createArchivedEventsRequestedAction(c, dispatch)),
  };
}

export const ArchivedEventsTableContainer = connect(mapStateToProps, mapDispatchToProps)(EventsTable);
